import {style} from 'typestyle'
import * as csstips from 'csstips'

export const searchHistory = style({

})

export const searchHistoryList = style({

})

export const searchHistoryListWrap = style({
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 10
})

export const searchHistoryTitleWrap = style({
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.betweenJustified,
    padding: '13px 15px 13px 15px'
})

export const searchHistoryTitle = style({
    fontSize: 18,
    color: '#000000',
    lineHeight: '22px',
    fontWeight: 500
})

export const deleteHistory = style({
    cursor: 'pointer',
    $nest: {
        'img': {
            width: 24,
            height: 24
        },
        '&:active': {
            opacity: 0.5
        }
    }
})

export const searchHistoryListItem = style({
    listStyle: 'none',
    display: 'inline-block',
    padding: '6px 12px 6px 12px',
    marginBottom: 10,
    fontSize: 14,
    color: '#666666',
    background: '#F7F7F7',
    borderRadius: 15,
    lineHeight: '18px',
    marginRight: 10,
    cursor: 'pointer',
    $nest: {
        '&:active': {
            background: '#e8e8e8'
        }
    }
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSearchPage/SearchHistory/SearchHistory.style.ts